import { Box, Typography } from '@mui/material';

import loginBg from '@assets/images/loginBg.svg';
import markAnyLfsLogo from '@assets/images/markAnyLfsLogo.svg';
import Button from 'shared/components/widgets/button';
import { setItem } from '@utils/localStorage';
import { useAuth } from 'contexts/authContext';
import { staffJwtIssueService } from '@services/public/staff/jwt-issue.service';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

const StaffLogin = () => {
  const { login, setIsLoggedIn } = useAuth();
  const navigate = useNavigate();

  const [isTransitioning, setIsTransitioning] = useState(false);

  const handleLoginSuccess = (response) => {
    setItem('api_access_token', response.accessToken);
    login();
  };

  const loginHandle = () => {
    const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
    const redirectUri = import.meta.env.VITE_GOOGLE_REDIRECT_URI;
    const scope = 'profile email';
    const responseType = 'code';
    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=${responseType}&scope=${encodeURIComponent(scope)}`;
    window.open(authUrl, 'googleLoginWindow', 'width=500,height=600');
  };

  useEffect(() => {
    async function handleMessage(event) {
      if (event.origin !== window.location.origin) {
        return;
      }
      const { code, error } = event.data;
      if (code) {
        handleJwtIssue(code);
      } else if (error) {
        console.error('Error during Google login:', error);
      }
    }
    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  const handleJwtIssue = async (code) => {
    setIsTransitioning(true);
    const resp = await staffJwtIssueService({
      googleToken: code,
    });
    setIsTransitioning(false);
    if (resp?.statusCode === 200) {
      if (resp?.response?.code === '33000') {
        navigate('/register-staff', {
          state: {
            encUserPk: resp?.response?.result?.encUserPk,
          },
        });
      } else if (resp?.response?.code === '1') {
        handleLoginSuccess(resp?.response?.result?.jwtSignInInfo);
        setIsLoggedIn(true);
        setItem('isLoginInitiated', 'true');
      }
    }
  };

  return (
    <Box
      display="flex"
      width="100%"
      justifyContent="center"
      alignItems="center"
      sx={{
        backgroundImage: `url(${loginBg})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <Box
        minWidth={440}
        maxWidth={440}
        display="flex"
        flexDirection="column"
        gap="30px"
        bgcolor="var(--base-white)"
        padding="40px"
        borderRadius="10px"
        border="1px solid var(--base-white)"
        boxShadow="0 0 10px 0 rgba(0, 0, 0, 0.25)"
      >
        <Box display="flex" justifyContent="center">
          <img
            src={markAnyLfsLogo}
            alt="Mark Any LFS Logo"
            width={274}
            height={51}
          />
        </Box>
        <Typography variant="h6" color="var(--base-black)" textAlign="center">
          대용량 파일 업로드 시스템
        </Typography>

        <Button
          variant="contained"
          disabled={isTransitioning}
          onClick={() => {
            loginHandle();
          }}
        >
          구글 로그인
        </Button>
      </Box>
    </Box>
  );
};

export default StaffLogin;
